import { store } from "../store/index";
import {
  filterInventary,
  listInventaryToExport,
  createInventary,
  inventaryNew,
  getProcess,
  modifyProcess,
  createStockAddInventory,
} from "../store/actions/InventaryActions";

/**
 * List Inventary
 */
export const listFilterInventary = async (filter) => {
  const result = await store.dispatch(filterInventary(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List export data
 */
export const listToExport = async (uuid) => {
  const result = await store.dispatch(listInventaryToExport(uuid));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const newInventary = async () => {
  const result = await store.dispatch(createInventary());
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const addInventary = async (param, values) => {
  const result = await store.dispatch(inventaryNew(param, values));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const processGetService = async (uuid) => {
  const result = await store.dispatch(getProcess(uuid));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const finishProcess = async (uuid) => {
  const result = await store.dispatch(modifyProcess(uuid));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};